export const MessageTypeList = [
  "NEW_ORGANIZATION",
  "UPDATE_CONFIG",
  "LOGIN_AS_ORG",
  "LOGGED_IN",
  "LOG_OUT",
  "RELOAD",
  "PREVIEW_EXPERIMENT",
  "INITIALIZED",
  "UPDATE_FIND_REPLACES",
  "NOT_LOGGED_IN",
  "PERFORMANCE_UPDATE",
  "DISCONNECT_OBSERVER",
  "CONNECT_OBSERVER",
  "NO_LOCAL_STORAGE",
  "CHECK_LOCAL_STORAGE",
  "ERROR_MESSAGE",
  "CURRENT_ORGANIZATION",
  "CONFIG_UPDATE_SUCCESS",
  "CONFIG_UPDATE_FAILED",
  "READY",
  "CLOSED",
  "igRequest",
] as const;
export type MessageType = (typeof MessageTypeList)[number];
